module.exports = __webpack_public_path__ + "static/img/A170.7e11d4c0.jpg";